// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1slxd","col":"styles_col__QsCRs"};